<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">{{ title }}</h4>
      </div>
      <div class="card-body">
        <div class="row form">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="addAsset_make">Make</label>
              <input type="text" name="Make" class="form-control" id="addAsset_make" placeholder="" v-model="trailer.make" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_model">Model</label>
              <input type="text" name="Model" class="form-control" id="addAsset_model" placeholder="" v-model="trailer.model" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_ID">Asset ID</label>
              <input type="text" class="form-control" id="addAsset_ID" placeholder="" v-model="trailer.assetId" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_techprovider">Tech Provider</label>
              <select id="addAsset_techprovider" class="form-control" v-model="trailer.techProvider" :disabled="readonly">
                <option value=""></option>
                <option value="dummyTracker">Dummy Tracker</option>
                <option value="bluerover">BlueRover</option>
              </select>
            </div>
            <div class="form-group">
              <label for="addAsset_techproviderID">Tech Provider ID</label>
              <input type="text" class="form-control" id="addAsset_techproviderID" placeholder="" v-model="trailer.techProviderId" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_trailertype">Trailer Type</label>
              <select id="addAsset_trailertype" class="form-control" v-model="trailer.trailerType" :disabled="readonly">
                <option value=""></option>
                <option value="DryVan">Dry Van</option>
                <option value="Flatbed">Flatbed</option>
                <option value="ContainerChassis">Container Chassis</option>
              </select>
            </div>
            <div class="form-group">
              <label for="addAsset_length">Length</label>
              <input type="text" name="Length" class="form-control" id="addAsset_length" placeholder="" v-model="trailer.length" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_liftgate">Lift Gate</label>
              <select id="addAsset_liftgate" name="Lift Gate" class="form-control" v-model="trailer.liftGate" v-validate="'required'" :disabled="readonly">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="form-group">
              <label for="addAsset_suspension">Suspension Type</label>
              <select id="addAsset_suspension" class="form-control" v-model="trailer.suspension" :disabled="readonly">
                <option value=""></option>
                <option value="Spring">Spring</option>
                <option value="Air">Air</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="addAsset_tare">Tare Weight</label>
              <input type="text" name="Tare Weight" class="form-control" id="addAsset_tare" placeholder="" v-model="trailer.tareWeight" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_gross">Gross Weight</label>
              <input type="text" name="Gross Weight" class="form-control" id="addAsset_gross" placeholder="" v-model="trailer.grossWeight" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_GIAI">GIAI</label>
              <input type="text" class="form-control" id="addAsset_GIAI" placeholder="" v-model="trailer.giai" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_refrigeration">Refrigeration Unit</label>
              <select id="addAsset_refrigeration" name="Refrigeration Unit" class="form-control" v-model="trailer.refrigerationUnit" v-validate="'required'" :disabled="readonly">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div class="card bg-white mb-3"> <!-- only if Refrigeration Unit is "yes" -->
              <div class="card-body">
                <h5 class="card-title">Refrigeration Unit Details</h5>
                <hr>
                <div class="form-group">
                  <label for="addAsset_techproviderID">Make</label>
                  <input type="text" name="refrigeration unit's Make" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="trailer.ru.make" v-validate="'required'">
                </div>
                <div class="form-group">
                  <label for="addAsset_techproviderID">Model</label>
                  <input type="text" name="refrigeration unit's Model" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="trailer.ru.model" v-validate="'required'">
                </div>
                <div class="form-group">
                  <label for="addAsset_techproviderID">Engine Type</label>
                  <input type="text" name="refrigeration unit's Engine Type" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="trailer.ru.engineType" v-validate="'required'">
                </div>
                <div class="form-group">
                  <label for="addAsset_techproviderID">Emissions Profile</label>
                  <div class="input-group">
                    <input type="number" min="0" name="refrigeration unit's Emissions Profile" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="trailer.ru.emissionsProfile" v-validate="'required|min_value:0'" />
                    <span class="input-group-addon su-group-addon">g CO2 per ton-mile</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TrailerForm',
  props: ['title', 'asset', 'readonly'],
  data: () => ({
    trailer: {
      make: '',
      model: '',
      assetId: '',
      tareWeight: '',
      grossWeight: '',
      giai: '',
      techProvider: '',
      techProviderId: '',
      trailerType: 'DryVan',
      length: '',
      liftGate: 'No',
      suspension: 'Spring',
      refrigerationUnit: 'No',
      // refrigeration unit data
      ru: {
        make: '',
        model: '',
        engineType: '',
        emissionsProfile: ''
      }
    }
  }),
  computed: {
    hasRefrigerationUnit: function() {
      return this.trailer.refrigerationUnit === 'Yes';
    }
  },
  mounted () {
  }, // end mounted
  methods: {
    getClearData: function() {
      let data = Object.assign({
        type: "Trailer"
      }, this.trailer);
      delete data.ru;
      delete data.refrigerationUnit;

      data.liftGate = data.liftGate === "Yes";
      if(this.hasRefrigerationUnit) data.ru = Object.assign({}, this.trailer.ru);
      return data;
    },
    loadData: function(data){
      if(!data) return;

      this.trailer.make = data.make || '';
      this.trailer.model = data.model || '';
      this.trailer.assetId = data.assetId || '';
      this.trailer.tareWeight = data.tareWeight || '';
      this.trailer.grossWeight = data.grossWeight || '';
      this.trailer.giai = data.giai || '';
      this.trailer.techProvider = data.techProvider || '';
      this.trailer.techProviderId = data.techProviderId || '';
      this.trailer.trailerType = data.trailerType || 'DryVan';
      this.trailer.length = data.length || '';
      this.trailer.liftGate = data.liftGate ? 'Yes' : 'No';
      this.trailer.suspension = data.suspension || 'Spring';
      this.trailer.refrigerationUnit = data.ru ? 'Yes' : 'No';

      if(!data.ru) return;
      this.trailer.ru.make = data.ru.make || '';
      this.trailer.ru.model = data.ru.model || '';
      this.trailer.ru.engineType = data.ru.engineType || '';
      this.trailer.ru.emissionsProfile = data.ru.emissionsProfile || '';
    }
  }
}
</script>

<style scoped>
.su-group-addon {
  background-color: #eee !important; 
  border: 1px solid #ccc !important;
}
</style>


// WEBPACK FOOTER //
// TrailerForm.vue?262b797e